// ALLVIEWS PRO subscription API client — mirrors /app/mobile/src/lib/pro-api.ts
import { apiFetch } from './api';

export const getProPricing = (category) => {
  const qs = category ? `?category=${encodeURIComponent(category)}` : '';
  return apiFetch(`/api/v1/pro/pricing${qs}`);
};

export const getProStatus = () => apiFetch('/api/v1/pro/status');

export const createProCheckout = (plan, originUrl) =>
  apiFetch('/api/v1/pro/checkout', {
    method: 'POST',
    body: JSON.stringify({ plan, origin_url: originUrl }),
  });

export const verifyProCheckout = (sessionId) =>
  apiFetch(`/api/v1/pro/verify?session_id=${encodeURIComponent(sessionId)}`);

export const cancelProSubscription = () =>
  apiFetch('/api/v1/pro/cancel', { method: 'POST', body: JSON.stringify({}) });

export const getProReferrals = () => apiFetch('/api/v1/pro/referrals');

// Phase 17 — Stripe Connect payouts endpoints
export const createPayoutAccount = () =>
  apiFetch('/api/v1/pro/referrals/payout-account', {
    method: 'POST',
    body: JSON.stringify({}),
  });

export const requestPayout = (amountCents) =>
  apiFetch('/api/v1/pro/referrals/payout-request', {
    method: 'POST',
    body: JSON.stringify(amountCents ? { amount_cents: amountCents } : {}),
  });

export const listPayouts = (cursor, limit = 20) => {
  const qs = new URLSearchParams();
  qs.set('limit', String(limit));
  if (cursor) qs.set('cursor', cursor);
  return apiFetch(`/api/v1/pro/referrals/payouts?${qs.toString()}`);
};
